import { render, staticRenderFns } from "./RevenueReductionReport.vue?vue&type=template&id=74b2cbbc&scoped=true&"
import script from "./RevenueReductionReport.vue?vue&type=script&lang=js&"
export * from "./RevenueReductionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b2cbbc",
  null
  
)

export default component.exports